import crudHandlers from './_crud'

export default (state, action) => {
	if (action.meta?.catalogKey) {
		const { catalogKey, requestId } = action.meta
		const catalog = state?.catalogs?.[catalogKey]
		let nextCatalog
		if (action.type === 'FETCH_EMPLOYEE_CATALOG') {
			nextCatalog = { ...catalog, requestId, is_fetching: !action.silent }
		} else {
			if (catalog?.requestId !== requestId) return state
			if (action.type === 'FINISH_EMPLOYEE_CATALOG') {
				nextCatalog = { ...catalog, is_fetching: false }
			} else if (action.type === 'LOAD_EMPLOYEES') {
				nextCatalog = { ...crudHandlers(catalog, action, 'employee'), loaded: true }
			} else {
				return state
			}
		}
		return { ...state, catalogs: { ...state?.catalogs, [catalogKey]: nextCatalog } }
	}
	const { type } = action
	switch (type) {
		case 'LOAD_DRIVERS_PERMISSIONS': 
			return { ...state, currentPermissions: action.payload }

		case 'GET_WIALON_DRIVERS': {
			var { response } = action

			return {
				...state,
				is_fetching: false,
				wialon_drivers: response.error ? [] : response,
			}
		}

		case 'LOAD_EMPLOYEES_BY_USERTYPE':{
			return {
				...state,
				entities: action.payload
			}
		}

		default:
			state = crudHandlers(state, action, 'employee')

			return state
	}
}
